import * as React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import styled from 'styled-components';

import { Collapsible } from '@/components/Elements/Collapsible';
import { PRODUCT_CATEGORY_TYPE_EMAIL } from '@/config/appConstants';
import { ProductCategoryTypes } from '@/types';

const FAQsContainerWrap = styled.div`
  .md__faqs__container > div:first-of-type {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }

  .md__faqs__container > div:last-of-type {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  .md__faqs__container {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
  }
`;

export type FAQsContainerProps = {
  collection?: ProductCategoryTypes;
};

export const FAQsContainer = ({ collection = PRODUCT_CATEGORY_TYPE_EMAIL }: FAQsContainerProps) => {
  const { t } = useTranslation();

  const getFAQsCollection = () => {
    const categoryCollection = [];

    for (let x = 1; ; x++) {
      const title = t(`FAQs.${collection}.title${x}`);
      const body = (
        <Trans
          components={
            // eslint-disable-next-line
            { a: <a />, bold: <strong /> }
          }
        >
          {t(`FAQs.${collection}.body${x}`)}
        </Trans>
      );

      if (title.startsWith('FAQs')) {
        break;
      }

      categoryCollection.push({
        title,
        body,
      });
    }

    return categoryCollection;
  };

  const categoryCollection = getFAQsCollection();

  return (
    <section>
      <FAQsContainerWrap>
        <section className="bg-md-bg-gray py-14">
          <div className="max-w-6xl m-auto overflow">
            <div className="p-3 lg:p-5">
              <div className="text-center mb-14 lg:mb-20">
                <h2 className="md__payments__title--h2">{t('FAQs.title')}</h2>
              </div>
              <div className="md__faqs__container shadow-xl">
                {categoryCollection.map((faq, index) => (
                  <div key={index} className="bg-white relative">
                    <Collapsible
                      trigger={
                        <p className="border-b-2 border-md-bg-gray text-md-mediumGray block text-lg lg:text-2xl leading-5 lg:leading-6 pt-5 lg:pt-9 pb-5 lg:pb-9 pr-[70px] pl-5 lg:pl-8 relative font-thin">
                          {faq.title}
                        </p>
                      }
                    >
                      <p className="text-base mt-3 lg:mt-0 pt-3 pb-10 pl-5 lg:pl-12 pr-14 lg:pr-16 font-lg lg:font-xl leading-5">
                        {faq.body}
                      </p>
                    </Collapsible>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      </FAQsContainerWrap>
    </section>
  );
};
